import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Institute } from '@lyceo/homi/shared/util-models';
import * as InstituteSelectors from './institute.selectors';

@Injectable({
  providedIn: 'root',
})
export class InstituteFacade {
  private readonly store: Store = inject(Store);

  public readonly allInstitutes: Signal<Institute[]> = this.store.selectSignal(
    InstituteSelectors.selectAllInstitutes,
  );
}
